import React, { useState, useEffect } from "react";
import DateRangePicker from "../general/DateRangePicker";
import "../../assets/css/mission-list.css";
import userAvatar from "../../assets/img/ico/questionmark.svg";
import companyLogo from "../../assets/img/logo.svg";
import { HashLink as Link } from "react-router-hash-link";

//TODO: faire le mode 'particulier'

const MissionListDashboard = ({ mode = "entreprise" }) => {
  const [missions, setMissions] = useState([]);
  const [sortBy, setSortBy] = useState("inProgress");
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  // Options de tri
  const sortOptions = [
    { value: "future", label: "Future mission" },
    { value: "inProgress", label: "Mission en cours" },
    { value: "history", label: "Historique" },
    { value: "cancelled", label: "Mission annulée" },
  ];

  // recup le type de tri actuel
  const getCurrentSortLabel = () => {
    const currentOption = sortOptions.find((option) => option.value === sortBy);
    return currentOption ? currentOption.label : "";
  };

  const fetchMissions = async () => {
    // TODO: Remplacer par appel API backend
    // Simulation des données basées sur la maquette
    setMissions([
      {
        id: 1,
        userName: "Lucas Prochon",
        userAddress: "15 adresse postale\n06000 Nice",
        jobTitle: "Receptioniste",
        startTime: "8h00",
        startDate: "21 mars 2025",
        endTime: "16h00",
        endDate: "21 mars 2025",
        avatarUrl: userAvatar,
        status: "inProgress",
      },
      {
        id: 2,
        userName: "Lucas Prochon",
        userAddress: "15 adresse postale\n06000 Nice",
        jobTitle: "Cuisinier",
        startTime: "8h00",
        startDate: "21 mars 2025",
        endTime: "16h00",
        endDate: "21 mars 2025",
        avatarUrl: userAvatar,
        status: "inProgress",
      },
      {
        id: 3,
        userName: "Lucas Prochon",
        userAddress: "15 adresse postale\n06000 Nice",
        jobTitle: "Cuisinier",
        startTime: "8h00",
        startDate: "21 mars 2025",
        endTime: "16h00",
        endDate: "21 mars 2025",
        avatarUrl: userAvatar,
        status: "inProgress",
      },
    ]);
  };

  useEffect(() => {
    fetchMissions();
  }, []);

  // === HANDLERS ===

  // Handler pour le custom dropdown

  const handleSortSelect = (value) => {
    setSortBy(value);
    setSortDropdownOpen(false);
    // TODO: Filtrer les missions localement ou refetch depuis l'API avec le nouveau tri
    console.log("Tri par:", value);
  };

  const handleDateChange = (newRange) => {
    setDateRange(newRange);
    // TODO: Filtrer les missions localement ou refetch depuis l'API avec la nouvelle plage de dates
    console.log("Plage de dates:", newRange);
  };

  const handleViewDetails = (missionId) => {
    // TODO: Implémenter la navigation vers la page de détail de la mission
    console.log("Voir détail mission:", missionId);
  };

  const handleOrderMission = () => {
    // TODO: Ouvrir un modal ou rediriger vers la page de commande
    console.log("Commander une nouvelle mission");
  };

  // TODO: Filtrer les missions affichées en fonction de sortBy et dateRange

  return (
    <div className="ml-dashboard-layout">
      <div className="ml-main-content">
        <h1>{mode === "particulier" ? "Mes missions" : "Missions"}</h1>
        <div className="ml-filters-bar">
          <div className="ml-sort-container">
            <label htmlFor="sort-missions-button">Trier par</label>
            <div
              className="custom-dropdown"
              onClick={() => setSortDropdownOpen(!sortDropdownOpen)}
            >
              <button
                type="button"
                id="sort-missions-button"
                className="custom-dropdown-button"
              >
                {getCurrentSortLabel()}
                <i
                  className={`fa-solid fa-chevron-down ${
                    sortDropdownOpen ? "rotate" : ""
                  }`}
                ></i>
              </button>

              {sortDropdownOpen && (
                <ul className="custom-dropdown-menu">
                  {sortOptions.map((option) => (
                    <li
                      key={option.value}
                      onClick={() => handleSortSelect(option.value)}
                      className={`custom-dropdown-item ${
                        sortBy === option.value ? "active" : ""
                      }`}
                    >
                      {option.label}
                      {sortBy === option.value && (
                        <i className="fa-solid fa-check check-icon"></i>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <div className="ml-date-range-container">
            <DateRangePicker onChange={handleDateChange} />
          </div>
        </div>

        <div className="ml-mission-list">
          {missions.map((mission) => (
            <div key={mission.id} className="ml-mission-card">
              <div
                className={`ml-avatar-block ${
                  mode === "particulier" ? "ml-logo-container" : ""
                }`}
              >
                <img
                  src={mode === "particulier" ? companyLogo : mission.avatarUrl}
                  alt={
                    mode === "particulier" ? "Company Logo" : mission.userName
                  }
                  className={`ml-avatar ${
                    mode === "particulier" ? "ml-avatar-logo" : ""
                  }`}
                />
              </div>
              <div className="ml-person-info">
                <span className="ml-user-name">{mission.userName}</span>
                <span className="ml-user-address">{mission.userAddress}</span>
              </div>
              <div className="ml-job-and-time-info">
                <span className="ml-job-title">{mission.jobTitle}</span>
                <div className="ml-mission-time">
                  <div className="ml-mission-time-block">
                    <span className="ml-mission-hour">{mission.startTime}</span>
                    <span className="ml-mission-date">{mission.startDate}</span>
                  </div>
                  <span className="ml-mission-arrow">&gt;</span>
                  <div className="ml-mission-time-block">
                    <span className="ml-mission-hour">{mission.endTime}</span>
                    <span className="ml-mission-date">{mission.endDate}</span>
                  </div>
                </div>
              </div>
              <Link to="/mission-detail-entreprise" className="ml-details-link">
                Voir le détail de la mission
              </Link>
            </div>
          ))}
          {missions.length === 0 && (
            <p>Aucune mission à afficher pour le moment.</p>
          )}
        </div>
      </div>

      <div className="ml-sidebar">
        {mode === "entreprise" && (
          <Link
            to={"/mission-creation"}
            className="btn fill green ml-order-mission-btn"
          >
            Commander une nouvelle mission
          </Link>
        )}
      </div>
    </div>
  );
};

export default MissionListDashboard;
